module.exports = __webpack_public_path__ + "static/media/2.eff4a0ef.jpg";